import React from "react";
import get from "lodash/get";

import { ContentType, DestinationType } from "../../constants";
import { bytesToSize } from "../helpers";

export function filterContentByDestinationType(
  content: Content[],
  selectedContent: Content[],
  destination: Destination
): Content[] {
  if (!destination) {
    return content;
  }
  let textSelected = selectedContent.find((c) => c.type === ContentType.TEXT);
  let fileSelected = selectedContent.find((c) => c.type === ContentType.FILE);
  return content.filter((c) => {
    if (destination.type === DestinationType.TWITTER) {
      if (
        c.type === ContentType.TEXT &&
        textSelected &&
        textSelected.id !== c.id
      )
        return false;
      if (
        c.type === ContentType.FILE &&
        fileSelected &&
        fileSelected.id !== c.id
      )
        return false;
      return true;
    }
  });
}

export function getFileMetaText(content: Content) {
  const size = get(content, "meta.size");
  const url = get(content, "meta.url");
  const name = get(content, "meta.name", "file");

  return url ? (
    <a href={url} target="_blank">
      {name}
      {size && ` (${bytesToSize(size)})`}
    </a>
  ) : (
    name
  );
}
